/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 数组去重
 *
 * @param arr 要去重的数组
 * @returns 去重后的数组
 */
export const unique = (arr: any) => {
  const seen = new Map();
  return arr.filter((item: any) => {
    return !seen.has(item) && seen.set(item, 1);
  });
};
